function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_101",
  "data-name": "Group 101",
  transform: "translate(-155.951 -113.281)"
}, React.createElement("path", {
  id: "Path_27",
  "data-name": "Path 27",
  d: "M156,117.195l-.049.6a9.331,9.331,0,0,0,15.952,1.261l.048-.6A9.331,9.331,0,0,0,156,117.195Zm7.811,4.542a3.623,3.623,0,1,1,3.9-3.32A3.623,3.623,0,0,1,163.811,121.737Z",
  transform: "translate(0 0)"
}), React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M164.127,116.323a1.818,1.818,0,1,0,1.817,1.818A1.816,1.816,0,0,0,164.127,116.323Z",
  transform: "translate(-0.025 -0.015)"
}));

var SvgEyeNocolor = function SvgEyeNocolor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 9.69,
    viewBox: "0 0 16 9.69",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEyeNocolor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye_nocolor.f5f46664.svg";
export { ForwardRef as ReactComponent };